// extracted by mini-css-extract-plugin
export var active = "Tab_active__EHZBt";
export var button = "Tab_button__52kmk";
export var onlyTab = "Tab_onlyTab__8mK82";